Vue.component("fullscreenVideo", {
    mixins: [SceneContentComponentMixin],
    template: `
        <transition name="fadeinvideo">
            <div class="fullscreenVideo__background" v-if="videoplayerready" @click="playVideo">

                <div class="fullscreenVideo__wrapper">
                    <button class="fullscreenVideo__btnClose" @click="close">
                        <img src="assets/img/ui/close-white.svg">
                    </button>

                    <video
                        id="fullscreenVideo__video"
                        :autoplay="autoplay"
                        :controls="controls"
                        :mute="mute"
                        :loop="loop"
                        playsinline
                        webkit-playsinline
                        type="video/mp4"
                        :src="video.src"
                        :poster="image.src"
                        @contextmenu.prevent=""

                        v-if="!isYoutubeVideo"
                    ></video>

                    <iframe :src="youtube" @contextmenu.prevent="" frameborder="0" v-if="isYoutubeVideo" 
                        allowfullscreen="allowfullscreen"
                        mozallowfullscreen="mozallowfullscreen" 
                        msallowfullscreen="msallowfullscreen" 
                        oallowfullscreen="oallowfullscreen" 
                        webkitallowfullscreen="webkitallowfullscreen"></iframe>
                </div>
            </div>
        </transition>
    `,
    data() {
        return {
            image: '',
            video: '',
            youtube: '',

            // Variables that can be set to customize video player component. 
            // These are the default values and can be overwritten in the manifest.
            autoplay: false,
            controls: true,
            mute: false,
            loop: false,

            // Variables for this instance to handle functionality
            videoplayerready: false,
            isVideoPaused: false
        }
    },
    methods: {
        playVideo() {
            // toggle play & pause
            this.isVideoPaused = !this.isVideoPaused;
        }
    },
    computed: {

        isYoutubeVideo() {
            return this.youtube !== ''
        }
    },
    mounted() {
        // handle intro animation
        this.videoplayerready = true;

        // start/stop video on start if autoplay is enabled
        this.isVideoPaused = !this.autoplay;
    },
})

touchKit.ComponentManager.register("fullscreenVideo", {
    singleton: true
});